import { render } from "./detail.vue?vue&type=template&id=e980fac0&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=e980fac0&scoped=true&lang=css"
import "./detail.vue?vue&type=style&index=1&id=e980fac0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e980fac0"]])

export default __exports__